import { GET_COUNTRIES } from './gql/country.list';
export const getCountriesQuery = (gqlInstance) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({
        query: GET_COUNTRIES,
        fetchPolicy: 'network-only',
        variables: {},
    })
        .then((response) => {
        return response.data.countries;
    });
};
//# sourceMappingURL=country.queries.js.map